export const isMobile = (value) => {
  if (value) {
    return /^(1[\d]{10})$/.test(value);
  }
  return true;
};

export const isPhone = (value) => {
  if (typeof value === 'string' && value !== '') {
    return /^([\d\-]{1,20})$/.test(value);
  }
  return true;
};

export const number = (value) => {
  if (typeof value === 'number') {
    if (isNaN(value)) {
      return false;
    }
    return true;
  } if (typeof value === 'string' && value !== '') {
    return /^([\d]{1,10}(\.[\d]{1,10}){0,1})$/.test(value);
  }
  return true;
};

// export const requiredWhenValueNotEquals = param => value => {
//   if (value === '' || value === param) {
//     return false
//   } else {
//     return true
//   }
// }
